import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query/src/types';

import api from 'utils/axios';

import { FavoriteIconsKeySnaked, TFavoriteIcons } from './types';

const keys = {
  getFavoriteIcons: ['favoriteIcons'],
};

const fetchFavoriteIcons = async () => await api.get<TFavoriteIcons>('/me/favorite_icon').then(({ data }) => data);

export function useFavoriteIcons(options: UseQueryOptions<TFavoriteIcons> = {}) {
  const queryClient = useQueryClient();

  return useQuery<TFavoriteIcons>(keys.getFavoriteIcons, fetchFavoriteIcons, {
    staleTime: 1000 * 60 * 5,
    initialData: () => {
      return queryClient.getQueryData(keys.getFavoriteIcons);
    },
    ...options,
  });
}

export function useUpdateFavoriteIcon() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: { eventType: FavoriteIconsKeySnaked; icon: string | null }) =>
      await api.patch<TFavoriteIcons>('/me/favorite_icon', data),
    {
      onSuccess: (data) => {
        queryClient.setQueriesData(keys.getFavoriteIcons, data.data);
      },
    },
  );
}

export async function usePrefetchFavoriteIcons() {
  const queryClient = useQueryClient();

  await queryClient.prefetchQuery(keys.getFavoriteIcons, fetchFavoriteIcons);
}
